import {
  MDBAlert,
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  downloadFaxFile,
  getForwardFaxInfo,
  getForwardGroupFaxInfo,
  receivedFaxDetails,
  receivedGroupFaxDetails,
} from "../../../apiclients/streamsapi_bridge";
import TopMessage from "../../../components/header/TopMessage";
import TopSuccess from "../../../components/header/TopSuccess";
import PopupLoader from "../PopupLoader";
import DeleteSntRecFax from "../phonesystem/DeleteSntRecFax";
import SendAFax from "./SendAFax";

function ReceivedFax({
  uniqueid,
  groupFaxFlag,
  faxDomain,
  primaryFax,
  userList,
  faxPhoneNums,
  isActive,
  groupname,
}) {
  const [isloading, setIsloading] = useState(false);
  const [internalError, setInternalError] = useState(false);
  const navigate = useNavigate();
  const [rerender, setrerender] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [receivedFax, setreceivedFax] = useState([]);
  const [deleteFax, setDeleteFax] = useState(false);
  const dtogglePopup = () => setDeleteFax(!deleteFax);
  const [selectedFaxId, setSelectedFaxId] = useState("");

  const [forwardFax, setForwardFax] = useState(false);
  const forwardFaxPopup = () => setForwardFax(!forwardFax);
  const [errorMessage, setErrorMessage] = useState(false);

  const [fileName, setFileName] = useState("");

  function deletethisFax(evntData, faxid) {
    evntData.preventDefault();
    evntData.stopPropagation();
    setSelectedFaxId(faxid);
    dtogglePopup();
  }

  useEffect(() => {
    if (uniqueid && uniqueid !== "" && isActive) {
      getReveivedFaxDetails();
    }
  }, [uniqueid, isActive]);

  async function getReveivedFaxDetails() {
    try {
      setIsloading(true);
      setInternalError(false);

      let response = null;
      if (groupFaxFlag) {
        response = await receivedGroupFaxDetails(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          uniqueid
        );
      } else {
        response = await receivedFaxDetails(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          uniqueid
        );
      }
      const rawData = await response.json();
      console.log(
        "getReveivedFaxDetails details :::::: " + JSON.stringify(rawData)
      );
      if (response.status === 200) {
        if (groupFaxFlag) {
          setreceivedFax(rawData?.receivedGrpfaxdetails ?? []);
        } else {
          setreceivedFax(rawData?.receivedfaxdetails ?? []);
        }
      } else if (response.status === 500) {
        setInternalError(true);
      } else {
        // navigate("/");
        setInternalError(true);
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
      setInternalError(true);
    } finally {
      setIsloading(false);
    }
  }

  async function handleDownload(e, faxid, fileName) {
    e.preventDefault();
    e.stopPropagation();
    try {
      let apiResponse = await downloadFaxFile(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        faxid
      );
      let filename = fileName;
      let saverepeMsg = (await apiResponse?.json()) ?? null;
      if (
        apiResponse.status == 200 &&
        !(saverepeMsg && saverepeMsg.status === "failed")
      ) {
        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        setInternalError(true);
        setErrorMessage(saverepeMsg?.message ?? "");
      }
    } catch (error) {
      console.log("Error ::::::::: " + error);
    }
  }

  let processdrows = [];
  receivedFax.map((fax, index) => {
    processdrows.push({
      faxInfo: fax,
      sno: parseInt(index) + 1,
      fileName: fax.file_name,
      faxPages: fax?.fax_pages ? parseInt(fax.fax_pages) : 0,
      from: fax.From + "",
      to: fax.To + "",
      date: fax.date + "",
      time: fax.time + "",
      recipientsEmail: fax.recipients_mmail + "",
      size: fax?.size ? parseInt(fax.size) : 0,
      // fax: fax.fax + "",
      faxType: fax.fax_type + "",
      status: fax.status + "",
      actions: (
        <>
          <div className="d-flex align-items-center ">
            <div
              className="custom-hover-bg p-1 cursor-pointer DownloadToolTip"
              onClick={(e) => handleDownload(e, fax.fax_id, fax.file_name)}
            >
              <MDBIcon icon="download" className="fs-5" color="primary" />
            </div>
            <div
              className="custom-hover-bg ms-3 p-1 cursor-pointer ShareToolTip"
              onClick={(e) => handleForwardFax(e, fax.file_name, fax.fax_id)}
            >
              <MDBIcon className="fs-5" fas icon="share" color="primary" />
            </div>
            <div
              className="custom-hover-bg ms-3 p-1 cursor-pointer deleteToolTip"
              onClick={(e) => deletethisFax(e, fax.fax_id)}
            >
              <MDBIcon color="primary" className="fs-5" icon="trash" />
            </div>
          </div>
        </>
      ),
    });
  });

  const actionData = {
    columns: [
      { label: "S.No", field: "sno" },
      { label: "File Name", field: "fileName" },
      { label: "Fax Pages", field: "faxPages" },
      { label: "From", field: "from" },
      { label: "To", field: "to" },
      { label: "Date", field: "date" },
      { label: "Time", field: "time", sort: false },
      ...(!groupFaxFlag
        ? [{ label: "Recipients Email", field: "recipientsEmail", sort: false }]
        : []),
      { label: "Size(KB)", field: "size" },
      ...(!groupFaxFlag
        ? [{ label: "Fax Type", field: "faxType", sort: false }]
        : []),
      { label: "Status", field: "status", sort: false },
      { label: "Actions", field: "actions", sort: false },
    ],
    rows: processdrows,
  };

  async function handleForwardFax(e, filename, faxid) {
    e.preventDefault();
    e.stopPropagation();
    setFileName(filename);
    setSelectedFaxId(faxid);

    // try {
    //   setIsloading(true);
    //   setInternalError(false);

    //   let response = null;
    //   if (groupFaxFlag) {
    //     response = await getForwardGroupFaxInfo(
    //       JSON.parse(sessionStorage.getItem("admin_session")).siteid,
    //       uniqueid
    //     );
    //   } else {
    //     response = await getForwardFaxInfo(
    //       JSON.parse(sessionStorage.getItem("admin_session")).siteid,
    //       uniqueid
    //     );
    //   }

    //   const rawData = await response.json();
    //   console.log(
    //     "getForwardFaxInfo details :::::: " + JSON.stringify(rawData)
    //   );
    //   if (response.status === 200) {
    //     // if (groupFaxFlag) {
    //     //   setSentFax(rawData?.sentGrpfaxdetail ?? []);
    //     // } else {
    //     //   setSentFax(rawData?.sentfaxdetail ?? []);
    //     // }
    //   } else if (response.status === 500) {
    //     setInternalError(true);
    //   } else {
    //     // navigate("/");
    //     setInternalError(true);
    //   }
    // } catch (e) {
    //   console.log(`Unable to process the request:${e}`);
    //   setInternalError(true);
    // } finally {
    //   setIsloading(false);
    // }

    forwardFaxPopup();
  }
  return (
    <>
      <div className="w-100 mt-3 usersFaxDataTable">
        <div className="actionbar"></div>
        <MDBDatatable
          search
          fixedHeader
          entries={50}
          hover
          data={actionData}
          sortField="Date"
          sortOrder="desc"
          pagination
          stopPropagation
        />
      </div>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {internalError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setInternalError(false)}
        >
          Internal Server Error
        </MDBAlert>
      )}
      {successMessage && (
        <>
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={5000}
          >
            <i className="fas fa-times-circle me-3"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        </>
      )}
      {deleteFax && (
        <PopupLoader
          title={"Delete Fax"}
          content={
            <DeleteSntRecFax
              faxid={selectedFaxId}
              setSuccessMessage={setSuccessMessage}
              setrerender={setrerender}
              onClose={dtogglePopup}
              groupFaxFlag={groupFaxFlag}
            />
          }
          onShow={setDeleteFax}
          onClose={dtogglePopup}
        />
      )}
      {forwardFax && (
        <PopupLoader
          title={"Forward Fax"}
          size={"lg"}
          content={
            <SendAFax
              faxPhoneNums={faxPhoneNums}
              uniqueid={uniqueid}
              faxDomain={faxDomain}
              primaryFax={primaryFax}
              groupFaxFlag={groupFaxFlag}
              userList={userList}
              forwardFlag={true}
              existFileName={fileName}
              groupname={groupname}
              selectedFaxId={selectedFaxId}
            />
          }
          onShow={setForwardFax}
          onClose={forwardFaxPopup}
        />
      )}
    </>
  );
}

export default ReceivedFax;
